import type { MaterialProjeto, Piece } from '@visualizador/shared';

/**
 * Nome do material para EXIBIR.
 *
 * Nunca devolve o `material_id`: ele perde acento e espaco
 * ("Carvao_Betula" != "Carvão Bétula") e e ambiguo — nomes diferentes podem
 * cair no mesmo id. O id serve so para casar/agrupar.
 *
 * Ordem: `material_nome` -> `material` (campo antigo, plugin velho) -> resolve
 * o `material_id` pela lista de materiais do projeto -> vazio (a linha some).
 *
 * Tambem conserta a exibicao de registros antigos que gravaram o ID no lugar do
 * nome: se o texto guardado for exatamente um id conhecido, mostra o nome dele.
 * Nao tentamos "despoluir" trocando "_" por espaco — isso nao recupera acento
 * nem distingue nomes diferentes.
 */
export function materialParaExibir(peca?: Piece | null, materiais?: MaterialProjeto[]): string {
  if (!peca) return '';
  const lista = materiais ?? [];
  const guardado = (peca.material_nome ?? '').trim() || (peca.material ?? '').trim();

  if (guardado) {
    const comoId = lista.find((m) => m.id === guardado);
    return (comoId?.nome ?? '').trim() || guardado;
  }

  const id = (peca.material_id ?? '').trim();
  if (!id) return '';
  return (lista.find((m) => m.id === id)?.nome ?? '').trim();
}
